import classNames from "classnames";
import { forwardRef, SelectHTMLAttributes } from "react";

const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, ...props }, ref) => {
    return (
      <select
        {...props}
        ref={ref}
        className={classNames(
          "cursor-pointer rounded-[5px] border-2 border-gray-200 bg-white px-2 py-1.5 focus:outline-none active:opacity-50 hover:opacity-50",
          className
        )}
      />
    );
  }
);

Select.displayName = "Select";

export default Select;
